import React, { useState, useEffect } from 'react';

const EclairLanguette = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  useEffect(() => {
    let timer;
    if (isMobile && isExpanded) {
      timer = setTimeout(() => {
        setIsExpanded(false);
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [isMobile, isExpanded]);

  const handleContainerClick = (e) => {
    if (isMobile) {
      if (!isExpanded) {
        e.preventDefault();
        setIsExpanded(true);
      }
      // If expanded, let the link work naturally
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes letterBounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-3px); }
            60% { transform: translateY(-2px); }
          }

          @keyframes logoRotate {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(20deg); }
          }

          @keyframes pulseGlow {
            0%, 100% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.3); }
            50% { box-shadow: 0 0 30px rgba(59, 130, 246, 0.6); }
          }

          .eclair-languette {
            transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);
            text-decoration: none !important;
          }

          .eclair-languette:hover {
            text-decoration: none !important;
          }

          .eclair-languette:hover .logo-rotate {
            animation: logoRotate 0.3s ease-out forwards;
          }

          .eclair-languette:hover {
            animation: pulseGlow 2s ease-in-out infinite;
          }

          .eclair-languette.mobile-expanded .logo-rotate {
            animation: logoRotate 0.3s ease-out forwards;
          }

          .eclair-languette.mobile-expanded {
            animation: pulseGlow 2s ease-in-out infinite;
          }

          .animate-text {
            animation: letterBounce 0.8s ease-in-out;
          }

          .animate-text-2 {
            animation: letterBounce 0.8s ease-in-out 0.2s;
          }

          .eclair-languette-container {
            position: fixed;
            bottom: 16px;
            right: 16px;
            z-index: 9999;
          }

          .eclair-languette-inner {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background-color: #111827;
            background-image: linear-gradient(135deg, #111827 0%, #1f2937 100%);
            transition: all 0.7s ease-out;
            position: relative;
            z-index: 10;
            overflow: hidden;
            cursor: pointer;
          }

          .eclair-languette:hover .eclair-languette-inner,
          .eclair-languette.mobile-expanded .eclair-languette-inner {
            width: auto;
            padding: 12px 24px;
            border-radius: 8px;
          }

          .eclair-logo {
            height: 24px;
            width: auto;
            filter: brightness(0) invert(1);
            transform-origin: center;
            transition: all 0.7s ease-out;
          }

          .eclair-languette:hover .eclair-logo,
          .eclair-languette.mobile-expanded .eclair-logo {
            height: 32px;
            margin-right: 12px;
          }

          .eclair-text {
            opacity: 0;
            white-space: nowrap;
            overflow: hidden;
            max-width: 0;
            transition: all 0.1s;
            color: white;
            font-size: 14px;
            font-weight: 500;
          }

          .eclair-languette:hover .eclair-text,
          .eclair-languette.mobile-expanded .eclair-text {
            opacity: 1;
            max-width: 200px;
            transition: all 0.5s 0.2s;
          }

          .eclair-text-line {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          .eclair-text-part {
            display: flex;
            align-items: center;
          }

          .eclair-text-bold {
            margin-left: 4px;
            font-weight: bold;
          }
        `}
      </style>

      <div className="eclair-languette-container">
        <a
          href="https://eclair.gg/t/oec"
          target="_blank"
          rel="noopener noreferrer"
          className={`eclair-languette ${isMobile && isExpanded ? 'mobile-expanded' : ''}`}
          onClick={handleContainerClick}
        >
          <div className="eclair-languette-inner">
            <img
              src="/assets/img/logos/eclair/Eclair.svg"
              className="eclair-logo logo-rotate"
              alt="Eclair"
            />

            <div className="eclair-text">
              <div className="eclair-text-line">
                <div className="animate-text">¿Una idea? Un sitio web.</div>
                <div className="eclair-text-part">
                  <span className="animate-text-2">En el tiempo de un</span>
                  <span className="eclair-text-bold">rayo</span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export default EclairLanguette;